export default __webpack_public_path__ + "KaTeX_SansSerif-Bold.f0ad0abc489e2942f9e185a885d31e0a.ttf";